export default "__VITE_ASSET__BTS$6OCA__"